import { Component } from '@angular/core';
import { TblCatUsuario } from './types/Tables';
import { EstacionesTVADB } from './DAO/EstacionesTVADB';
declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  userSesion: TblCatUsuario;
  moduleName: string;
  menus: any;
  flagLogin: boolean;
  db: EstacionesTVADB;
  flag: boolean;

  constructor() { }
}
